import type { ClientProfile } from '@syfo/types/api.client.types';

export enum ShadeMode {
  Light = 'light',
  Dark = 'dark'
}

export interface AuthState {
  isAuthenticated: boolean | null; // null = loading, false = not authenticated, true = authenticated
  userProfile: ClientProfile | null;
}

export interface ThemeState {
  mode: ShadeMode;
}

export interface FeedbackState {
  isOpen: boolean;
  isSending: boolean;
  lastSent: string | null;
  error: string | null;
}